import { useId, type ReactNode } from 'react'

import { cx } from './hooks'

export interface CardProps {
  title?: ReactNode
  subtitle?: ReactNode
  /** Controls in the header's trailing edge: a segmented control, a link. */
  actions?: ReactNode
  footer?: ReactNode
  children?: ReactNode
  className?: string
  headingLevel?: 2 | 3
  busy?: boolean
}

/** The dark surface every dashboard tile sits on. A titled card is a labelled region. */
export function Card({
  title,
  subtitle,
  actions,
  footer,
  children,
  className,
  headingLevel = 2,
  busy,
}: CardProps) {
  const headingId = useId()
  const Heading = headingLevel === 2 ? 'h2' : 'h3'
  return (
    <section
      className={cx('ci-card', className)}
      aria-labelledby={title ? headingId : undefined}
      aria-busy={busy || undefined}
    >
      {title || actions ? (
        <header className="ci-card__header">
          <div className="ci-card__titles">
            {title ? (
              <Heading id={headingId} className="ci-card__title">
                {title}
              </Heading>
            ) : null}
            {subtitle ? <p className="ci-card__subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="ci-card__actions">{actions}</div> : null}
        </header>
      ) : null}
      <div className="ci-card__body">{children}</div>
      {footer ? <footer className="ci-card__footer">{footer}</footer> : null}
    </section>
  )
}
